export const NETTE_IMPORT_YAML = `#yamlPreprocessor=on
project:
  name: recipe-nette
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: php-apache@8.3
    buildFromGit: https://github.com/zeropsio/recipe-nette@main
    enableSubdomainAccess: true
    envSecrets:
      ADMIN_PASSWORD: <@generateRandomString(<24>)>
      APP_ENV: dev # for this example, in production it should be set to \`prod\` (or anything else than \`dev\`)
    verticalAutoscaling:
      minRam: 0.25
      minFreeRamGB: 0.125

  - hostname: db
    type: postgresql@16
    mode: NON_HA
    priority: 10

  - hostname: redis
    type: keydb@6
    mode: NON_HA
    priority: 10

  - hostname: adminer
    type: php-apache@8.3
    buildFromGit: https://github.com/zeropsio/recipe-adminer@main
    enableSubdomainAccess: true
    maxContainers: 1`;
